import { Injectable } from '@angular/core';
import { WorkingTimeModel } from '../../../models/user/working-time.model';
import { DateTimeHelper } from '../../../../features/calendar/util/date-time-helper';
import { UserModel } from '../../../models/user/user.model';
import { assert } from '../../../assert/assert';
import { pairwise } from '../../../../shared/functions/array-functions';
import { FixInterval } from '../../../../features/calendar/components/time-block/types/time-block-types';

@Injectable({
  providedIn: 'root',
})
export class WorkingTimeService {
  /**
   * @return Returns the working time in seconds.
   **/
  public getWorkingTime(date: Date, user: UserModel, fixIntervalType: FixInterval): number {
    const foundEntry = this.getWorkingTimeEntry(date, user);
    const workingTime = this.getWorkingTimeForDay(foundEntry, date.getDay(), fixIntervalType);
    return DateTimeHelper.hoursToSeconds(workingTime);
  }

  public getCurrentWorkingTimeEntry(user: UserModel): WorkingTimeModel {
    assert(user.workingTimeEntries !== null && user.workingTimeEntries.length > 0);
    return user.workingTimeEntries[user.workingTimeEntries.length - 1];
  }

  private getWorkingTimeForDay(
    foundEntry: WorkingTimeModel,
    dayOfWeek: number,
    fixIntervalType: FixInterval,
  ): number {
    const factor = fixIntervalType === FixInterval.FullWorkingDay ? 1 : 0.5;
    switch (dayOfWeek) {
      case 1: // Monday
        return foundEntry.monday! * factor;
      case 2: // Tuesday
        return foundEntry.tuesday! * factor;
      case 3: // Wednesday
        return foundEntry.wednesday! * factor;
      case 4: // Thursday
        return foundEntry.thursday! * factor;
      case 5: // Friday
        return foundEntry.friday! * factor;
      case 6: // Saturday
        return foundEntry.saturday! * factor;
      case 0: // Sunday
        return foundEntry.sunday! * factor;
    }
    return -1;
  }

  private getWorkingTimeEntry(date: Date, user: UserModel) {
    const workingTimeEntries = [...user.workingTimeEntries];

    // add dummy entry at beginning and the end
    workingTimeEntries.push({ userId: null, startingFrom: null });
    workingTimeEntries.unshift({ userId: null, startingFrom: null });

    const intervals = pairwise<boolean>(
      workingTimeEntries,
      (first: WorkingTimeModel, second: WorkingTimeModel) => {
        return DateTimeHelper.isDateInOpenInterval(date, {
          start: first.startingFrom ?? null,
          end: second.startingFrom ?? null,
        });
      },
    );

    const entryIndex = intervals.indexOf(true) === 0 ? 1 : intervals.lastIndexOf(true);
    return workingTimeEntries[entryIndex];
  }
}
